import { Injectable, ErrorHandler } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  IApiResponse,
  IBillingDto,
  ICustomerOrderDto,
  IFilterPaginationDto,
  IOrderDto,
  IPagination,
  IRestaurantDto,
} from '../models';

@Injectable()
export class OrderService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getOrderList(model: IPagination): Observable<ICustomerOrderDto[]> {
    return this.post(`order/list`, model);
  }

  public getCustomerOrder(id: number): Observable<IOrderDto> {
    return this.get(`order/customerOrder/${id}`);
  }

  public getOrder(id: string): Observable<IOrderDto> {
    return this.get(`order/${id}`);
  }

  public saveOrder(model: IBillingDto): Observable<IApiResponse<boolean>> {
    return this.post(`order/save`, model);
  }

  public previewOrder(
    model: IBillingDto
  ): Observable<IApiResponse<IBillingDto>> {
    return this.post(`order/preview`, model);
  }
}
